export default __webpack_public_path__ + "static/media/auth_logo.5e36e952.svg";